import * as React from 'react';
import { useEffect } from 'react';
import ProgressBar from '../ProgressBar';
import Icons from '../../icons';
import { shortFileName, getImagePreview } from '../../common/util';
import { fileIconBasedOnFileName } from '../../containers/WorkkardDetail/utils';

export const IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'gif']);

export const getFileExtension = (fileName) => {
    const parts = (fileName || '').split('.');
    return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
};

const renderFileIcon = (fileData, fetchedPreviewUrl) => {
    const extension = getFileExtension(fileData.name);
    if (IMAGE_EXTENSIONS.has(extension)) {
        return <img src={fileData.localUrl || fetchedPreviewUrl} alt={fileData.name || 'uploaded file'} />;
    }
    return <Icons name={fileIconBasedOnFileName(extension)} />;
};

const FileList = (props) => {
    const { data, isSingleFile, onRemoveFile, saveAndUpdateFileCaption, hideCaption } = props;
    const [progress, setProgress] = React.useState(0);
    const [fetchedPreviewUrl, setFetchedPreviewUrl] = React.useState(null);

    useEffect(() => {
        if (!data?.isLoading) {
            return undefined;
        }
        setProgress(0);
        const interval = setInterval(() => {
            setProgress((per) => (per < 98 ? per + 2 : per));
        }, 700);
        return () => clearInterval(interval);
    }, [data?.isLoading]);

    const isImageFile = IMAGE_EXTENSIONS.has(getFileExtension(data?.name));

    useEffect(() => {
        if (data?.isLoading || !isImageFile || data?.localUrl || !data?.guid) {
            setFetchedPreviewUrl(null);
            return undefined;
        }
        return getImagePreview(data.guid, setFetchedPreviewUrl);
    }, [data?.isLoading, isImageFile, data?.localUrl, data?.guid]);

    const updateCaption = (caption, fileData) => {
        const { guid, name, size, url, uploadDate } = fileData;
        let fileJson = { guid, name, size, caption, url };
        if (fileData.hasOwnProperty("isWorkkardFile")) {
            fileJson = { ...fileJson, isWorkkardFile: fileData.isWorkkardFile };
        }
        if (isSingleFile) {
            fileJson.uploadDate = uploadDate;
        }
        saveAndUpdateFileCaption(fileJson);
    };

    if (data && !data.isLoading) {
        const displayName = data.original?.length ? data.original : data.name;

        const trimCaptionOnBlur = () => {
            const trimmedCaption = (data.caption || '').trim();
            if (trimmedCaption === data.caption) return;
            updateCaption(trimmedCaption, data);
        };

        return (
            <li>
                <div className="uploadImage attachment bbb">
                    {renderFileIcon(data, fetchedPreviewUrl)}
                </div>
                <div className="uploadImageInfo">
                    <span title={displayName} className="fileName">
                        {shortFileName(displayName)}
                    </span>
                    {!hideCaption && (
                        <input
                            type="text"
                            maxLength={180}
                            data-actiontype="change"
                            placeholder="Type your caption here..."
                            value={data.caption || ''}
                            onBlur={trimCaptionOnBlur}
                            onChange={(e) => updateCaption(e.target.value, data)}
                        />
                    )}
                    <button
                        type="button"
                        className="iconButtonReset close btn-cc__transparent"
                        aria-label={`Remove ${data.name || 'file'}`}
                        data-image={data.name}
                        data-guid={data.guid}
                        data-actiontype="remove"
                        onClick={onRemoveFile}
                    >
                        <Icons name="closeFilled" className="icon" />
                    </button>
                </div>
            </li>
        );
    }

    const currentItem = data?.id ?? data?.name;

    return (
        <li>
            <div className="uploadImage progressUpload">
                {`${progress}%`}
            </div>
            <div className="uploadImageInfo flexGrow">
                <div className="uploadedInfo">
                    <span className="fileName" title={data?.name}>{shortFileName(data?.name)}</span>
                    <ProgressBar percentage={progress} progressBarType={'SuccessFile'} />
                </div>
                <button
                    type="button"
                    className="alignMiddle iconButtonReset close btn-cc__transparent"
                    aria-label={`Remove ${data?.name || 'file'}`}
                    data-currentitem={currentItem}
                    onClick={onRemoveFile}
                >
                    <Icons name="closeFilled" className="icon" />
                </button>
            </div>
        </li>
    );
};

export default FileList;
